import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG } from "@hvsin/ui-registry-contracts";
import { UserClientRegistrar } from "./user-client-registrar.js";
export function userClientMod() {
    return {
        name: "user-client",
        // SSR 容器中仅加载 ui-registry，不需要 user/auth（它们是服务端 mod）
        modDependencies: ["ui-registry"],
        serviceDefs: [
            {
                serviceTag: "userClientRegistrar",
                serviceImpl: UserClientRegistrar,
                dependencies: [PAGE_ROUTE_REGISTRY_INTERFACE_TAG],
            },
        ],
    };
}
//# sourceMappingURL=mod.js.map